import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { AccountType, GroupDto, UserDto } from 'UvExplorerServer.Dtos.TS/Auth';
import { UserComponent } from '../user/user.component';
import { MessageService } from 'base';
import { UsersService } from '../../services/users.service';


@Component({
    selector: 'user-dialog',
	templateUrl: './user-dialog.component.html'
})
export class UserDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public target: UserDto;

	@Input()
	public create: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<UserDto>;

	@Output()
	public onCancel: EventEmitter<any>;

    @ViewChild(UserComponent, { static: true })
	public user: UserComponent;

	private buttonClicked: boolean;

	constructor(private usersService: UsersService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.visible = false;
		this.target = null;
		this.create = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<UserDto>();
		this.onCancel = new EventEmitter<any>();
		this.buttonClicked = false;
	}

	public get enableOk(): boolean {
		return this.user.enableApply;
	}

	public get dialogTitle(): string {
		return (this.create ? "Create User" : "Edit User");
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		if (this.buttonClicked) {
			this.buttonClicked = false;
		}
		else {
			this.doCancelActions();
		}
	}

	public onCancelClicked(): void {
		this.buttonClicked = true;
		this.doCancelActions();
	}

	private doCancelActions(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onOkClicked(): void {
		let isUpdate = !this.create;
		if (isUpdate && !this.updateIsSafe()) {
			this.messageService.displayErrorMessage("Cannot remove last administrator");
		}
		else {
			this.apply();
		}
	}

	private updateIsSafe(): boolean {
		// Do not allow the last active native admin user to be removed
		if (!!this.target && this.isActiveNativeAdmin(this.target) &&
			!this.user.getIsActiveNativeAdmin()) {

			let activeNativeAdmins = this.activeNativeAdmins;
			return (activeNativeAdmins.length > 1);
		}
		else {
			return true;
		}
	}

	private get activeNativeAdmins(): UserDto[] {
		return this.usersService.users.ToArray().filter(u => this.isActiveNativeAdmin(u))
	}

	private isActiveNativeAdmin(user: UserDto): boolean {
		return (user.IsAdmin && user.IsActive && user.AccountType == AccountType.Native);
	}

	private apply(): void {
		if (this.target) {
			let userPassword: string = this.user.getPassword();
			this.user.applyTempChanges();

			if (this.create) {
				this.usersService.createUser(this.target, this.user.addedUserGroups, userPassword).subscribe(
					(result: UserDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("User successfully created");
					},
					(error) => {
						this.messageService.displayErrorMessage("Creating user failed");
					});
			}
			else {
				this.usersService.updateUser(this.target, this.user.addedUserGroups,
					this.user.removedUserGroups, userPassword).subscribe(
					(result: UserDto) => {
						this.buttonClicked = true;
						this.hide();
						this.onOk.emit(result);
						this.messageService.displayInfoMessage("User successfully updated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Updating user failed");
					});
			}
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

	}

}
